<template>
  <div>
    <b-modal
      title="Benchmark Bulk Upload"
      v-model="showBulkUploadModal"
      size="lg"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            @vdropzone-success="vsuccess"
            :options="dropzoneOptions"
            v-on:vdropzone-sending="sendingEvent"
            :useCustomSlot="true"
            class="m-5 p-3"
            style="border:dashed 1px"
          >
            <div class="dropzone-custom-content">
              <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
              <div class="subtitle">...or click to select a file from your computer</div>
            </div>
          </vue-dropzone>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Your Bulk is being Uploading......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Your Bulk has been uploaded successfully.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="float-right">
          <b-button
            class="mr-3"
            variant="outline-danger"
            v-if="!uploading"
            @click="resetModal"
          >Cancel</b-button>
          <b-button
            variant="outline-success"
            v-if="!uploading && !responseSuccess"
            @click="uploadFile"
          >Upload</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import VueDropzone from "../Dropzone/VueDropzone";
import uid from "uid";
export default {
  name: "BenchmarkBulkUploadModal",
  components: {
    VueDropzone
  },
  data() {
    return {
      responseSuccess: false,
      submiting: false,
      uploading: false,
      showBulkUploadModal: false,
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL + "v1/benchmark/thirdparties/import",
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        autoProcessQueue: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        }
      }
    };
  },
  // acceptedFiles: this.fileFormats.join(),
  created() {
    EventBus.$on("onShowBulkUploadModal", value => {
      this.showBulkUpload();
    });
  },
  methods: {
    showBulkUpload() {
      this.showBulkUploadModal = true;
    },
    uploadFile() {
      if (this.$refs.myVueDropzone.getQueuedFiles().length > 0) {
        // this.submiting = true;
        this.uploading = true;
        this.$refs.myVueDropzone.processQueue();
      }
    },
    resetModal() {
      this.showBulkUploadModal = false;
      this.submiting = false;
      this.responseSuccess = false;
    },
    readableBytes(bytes) {
      var i = Math.floor(Math.log(bytes) / Math.log(1024)),
        sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + " " + sizes[i];
    },
    vsuccess(file, response) {
      this.uploading = false;
      this.submiting = false;
      this.responseSuccess = true;
      // let uploadedFile = {};
      if (response && response.url) {
        // uploadedFile = {
        //   fileId: uid(),
        //   filename: file.name,
        //   caption: { english: this.slideCaption },
        //   text: { english: this.slideText },
        //   size: file.size,
        //   type: file.type,
        //   url: response.url
        // };
        // this.files.push(uploadedFile);
      }
      this.$bvToast.toast(
        "Your bulk upload file has been successfully uploaded and is now processed",
        {
          title: "File Upload is complete",
          noAutoHide: false,
          appendToast: true
        }
      );
      this.$refs.myVueDropzone.removeAllFiles();
    },
    sendingEvent(file, xhr, formData) {
      formData.append("user_id", localStorage.getItem("userId"));
      // formData.append("company_id", this.$route.params.id);
    }
  },
  props: {
    fileFormats: Array
  }
};
</script>